module.exports = __webpack_public_path__ + "bdccdf3d932ec303c5af3c26ad1f7ec7.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/775.png
// module id = 1696
// module chunks = 2